export default class JSONstringifyWithoutNulls {
    /**
     * toJSON method is for JSON.stringify() to clean up the object
     * @returns Generic object or properties and values that weren't null in the Request object
     */
    toJSON() {
        const returnObject = {};
        for (const propertyKey in this) {
            if (propertyKey === 'request') {
                continue;
            }
            const propertyValue = this[propertyKey];
            if (propertyValue !== null) {
                returnObject[propertyKey] = propertyValue;
            }
        }
        return returnObject;
    }
}
